import { MainContainer } from "../../component/container";
import Img1 from '../../assets/image/loc1.jpg'
import Img2 from '../../assets/image/Loc2.gif'
import Img3 from '../../assets/image/Loc3.gif'
import Img4 from '../../assets/image/Loc4.gif'
import Land from '../../assets/image/banneLand.gif'

import ICO from '../../assets/ico/charity.png'
import Kin from '../../assets/video/kn.mp4'
import Mb from '../../assets/video/lac.mp4'
import Mia from '../../assets/video/miami.mp4'
import BouncingIcon from '../../component/BouncingIcon';
import React, { useEffect, useRef, useState } from "react";
import { TbPointFilled } from "react-icons/tb";
import { Element, Link } from 'react-scroll';
import { useNavigate } from "react-router-dom";
// import { useNavigate } from "react-router-dom";

export default function Location() {
    const navigate = useNavigate();
    const [videos] = useState([Kin, Mb, Mia]);

    const [currentIndex, setCurrentIndex] = useState(0);
    const videoRef = useRef(null);

    useEffect(() => {
        const currentVideoRef = videoRef.current;
        const handleVideoEnded = () => {
            console.log(`Video ${currentIndex} ended. Passing to video id ${currentIndex + 1}`);

            setCurrentIndex((currentIndex + 1) % videos.length);

            currentVideoRef.load();
            currentVideoRef.play();
        };

        currentVideoRef.addEventListener('ended', handleVideoEnded);

        return () => {
            currentVideoRef?.removeEventListener('ended', handleVideoEnded);
        };
    }, [currentIndex, videos]);

    const changerVideo = (index) => {
        setCurrentIndex(index);
        videoRef.current.load();
        videoRef.current.play();
    };

    const Section = ({ title, image, children }) => {
        const calculerMoitieLongueur = (texte) => (texte ? Math.floor(texte.length / 2) : 0);

        const moitieLongueurTitre = calculerMoitieLongueur(title);
        return (
            <div className=' text-left  mt-3'>
                <div className="flex flex-col text-left mt-10">
                    <div className='text-left font-extrabold text-lg text-[#87ceeb] relative inline-block'>
                        {title}
                        <span
                            className="absolute inset-0 bg-gradient-to-r h-1 top-8 text-left from-[#87ceeb] to-transparent flex items-left"
                            style={{ width: `calc(${moitieLongueurTitre}ch)` }}
                        ></span>


                    </div>
                    <div className="flex  mt-5">
                        <div className="flex flex-col sm:flex-row gap-5 sm:min-w-[450px]">
                            <img src={image} alt={title} className='' />
                            {children}
                        </div>
                    </div>

                </div>

            </div>

        )
    }

    return (

        <MainContainer page='LOCATION'>
            <div id='content' className="">
                <video
                    className="h-screen w-screen mt-0 object-cover opacity-90 transition-opacity duration-1000 ease-in-out"
                    autoPlay
                    playsInline
                    muted
                    ref={videoRef}
                >
                    <source src={videos[currentIndex]} type="video/mp4" />
                </video>

                <div className="w-full absolute top-1/2 left-0 transform -translate-y-1/2 2xl:px-80 xl:px-52 px-10">
                    <div className="">
                        <div className="bg-[#87ceeb] bg-opacity-70 p-4 rounded-full">
                            <h1 className="text-lg sm:text-4xl font-bold text-white text-center">LOCATIONS.</h1>
                        </div>
                    </div>
                </div>
                <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2 flex">
                    {videos.map((x, i) => {
                        return (
                            <TbPointFilled key={i} size={25} className={`${i === currentIndex ? 'text-[#87ceeb]' : 'text-black'} cursor-pointer hover:text-[#bfd6df]`} onClick={() => { changerVideo(i) }} />
                        )
                    })}
                </div>
                {/* Votre composant BouncingIcon */}
                <Link to="Scroll" smooth={true} duration={500}>
                    <BouncingIcon />
                </Link>
            </div>
            <Element name="Scroll" className="element"><div className='min-h-[2px]'></div></Element>

            <div className="2xl:px-80 xl:px-52 px-10 mt-24">
                <div className=' text-center  mt-32 text-[#87ceeb]'>
                    The Amero-Congo Relief Foundation, Inc ( The ACRFI ), is a non profit and charitable organization incorporated in the State of Florida, US and legally operating in Miami Florida, and in 3 States of the Democratic Republic of Congo (KATANGA, KASAI & KINSHASA States).
                </div>

                <div className='text-center font-bold text-lg mt-2'>Our locations are :</div>
                <div className="grid gap-4 lg:grid-cols-2 justify-center">
                    <Section title={'THE ACRFI-HEADQUARTER / MIAMI, FL'} image={Img1} >
                        <div className="flex items-left justify-left flex-col">
                            <span className="">1167 N.W. 49th street</span>
                            <span className="">Miami, Fl. 33127</span>
                            <span className="">E-mail: admin@theacrfi.org</span>
                            <span className="">Tel: 305-633-0094 / 305-607-2284</span>

                            <span className="mt-5">To visit the acrfi-Miami team, click here</span>
                        </div>
                    </Section>

                    <Section title={'THE ACRFI-KATANGA / CONGO (DRC)'} image={Img2} >
                        <div className="flex items-left justify-center flex-col">
                            <span className="">2996 Lac Kipopo, Q.Gambela II</span>
                            <span className="">Commune Lubumbashi</span>
                            <span className="">Katanga, DRC</span>

                            <span className="mt-5">E-mail: admin@theacrfi.org</span>
                            <span className="">Tel: 243-99-873-7019</span>
                        </div>
                    </Section>

                    <Section title={'THE ACRFI-KASAI / CONGO (DRC)'} image={Img3} >
                        <div className="flex items-left justify-center flex-col">
                            <span className="">Theresienne sisters</span>
                            <span className="">Q Bonzola / Mbuji Mayi</span>
                            <span className="">Kasai oriental, DRC</span>

                            <span className="mt-5">E-mail: admin@theacrfi.org</span>
                            <span className="">Tel: 243-99-927-0737</span>
                        </div>
                    </Section>

                    <Section title={'THE ACRFI-KINSHASA / CONGO (DRC)'} image={Img4} >
                        <div className="flex items-left justify-center flex-col">
                            <span className="">17, Avenue Mbandaka, Q/Kingabwa</span>
                            <span className="">C/Llimete-Kinshasa</span>
                            <span className="">Dem. rep. of Congo        </span>

                            <span className="mt-5">E-mail: admin@theacrfi.org</span>
                            <span className="">Tel: 243-99-812-7675</span>
                        </div>
                    </Section>
                </div>

                <div className='text-center font-extrabold text-2xl text-[#87ceeb] mt-16'>
                    Land of the future acrfi orphanage
                </div>
                <div className='mt-5'>
                    <img src={Land} alt="Land" className='w-full' />
                </div>

                <div className="mt-10 flex flex-col text-center">
                    <span>
                        To prevent the interruption of the care we provide to orphans in the Congo, DRC, we need an orphanage to shelter and monitor the progress of these children.
                    </span>

                    <span className="mt-4">
                        We possess a land; big enough to build an orphanage, school and health facility; but our mean are limited!
                    </span>

                    <span className="mt-4">
                        Would you consider becoming a part of this project today?
                    </span>

                    <span className="mt-4">
                        Please donate and add your name to the list of our golden angelic donors for orphans of the Congo (DRC)
                    </span>

                    <span className="mt-4">
                        For your gift to save a life, please click below and securely donate using PayPal; or go to donate today and choose a different way to send your donations. As always,thank you in advance for your caring heart!

                    </span>

                    <div className="flex flex-col items-center justify-center">
                        <div className="flex items-center text-blue-400 gap-3">Donate today and make a difference in their lives today! by clicking to this icon <img src={ICO} alt={'ICO'} sizes={40} className="cursor-pointer" /> </div>
                        <div>Or go to: <span className="text-blue-400 hover:underline cursor-pointer" onClick={() => { navigate('/Donate') }}>donate today</span> and choose your best way to give to the work of God!</div>
                    </div>
                </div>
            </div>
        </MainContainer>
    )
}